/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    ChangeUserDataRequest,
    ChangeUserDataResponse,
    FindUsersResponse,
    NutzerAnlageRequest,
    NutzerAnlageResponse,
    NutzerLoeschenRequest,
    UserData
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class UserApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht das Ändern von Nutzerdaten des aktuell eingeloggten Nutzers.
 * @summary Ändere Nutzerdaten
 */
 changeUserData<TData = ChangeUserDataResponse>(changeUserDataRequest: ChangeUserDataRequest, options?: HttpClientBodyOptions): Observable<TData>;
 changeUserData<TData = ChangeUserDataResponse>(changeUserDataRequest: ChangeUserDataRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 changeUserData<TData = ChangeUserDataResponse>(changeUserDataRequest: ChangeUserDataRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  changeUserData<TData = ChangeUserDataResponse>(
    changeUserDataRequest: ChangeUserDataRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/userprofil/changeUserData`,
      changeUserDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/userprofil/changeUserData`,
      changeUserDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/userprofil/changeUserData`,
      changeUserDataRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen von mit der VSNR verknüpften Nutzerdaten.
 * @summary Finde mit einer VSNR verknüpfte Nutzer
 */
 findUsersByVsnr<TData = FindUsersResponse>(vsnr: string, options?: HttpClientBodyOptions): Observable<TData>;
 findUsersByVsnr<TData = FindUsersResponse>(vsnr: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 findUsersByVsnr<TData = FindUsersResponse>(vsnr: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  findUsersByVsnr<TData = FindUsersResponse>(
    vsnr: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/userprofil/byVsnr/${vsnr}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/userprofil/byVsnr/${vsnr}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/userprofil/byVsnr/${vsnr}`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Anlegen eines neuen Nutzers.
 * @summary Lege neuen Nutzer an
 */
 starteNutzerAnlage<TData = NutzerAnlageResponse>(nutzerAnlageRequest: NutzerAnlageRequest, options?: HttpClientBodyOptions): Observable<TData>;
 starteNutzerAnlage<TData = NutzerAnlageResponse>(nutzerAnlageRequest: NutzerAnlageRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 starteNutzerAnlage<TData = NutzerAnlageResponse>(nutzerAnlageRequest: NutzerAnlageRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  starteNutzerAnlage<TData = NutzerAnlageResponse>(
    nutzerAnlageRequest: NutzerAnlageRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/userprofil/`,
      nutzerAnlageRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/userprofil/`,
      nutzerAnlageRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/userprofil/`,
      nutzerAnlageRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Löschen eines Nutzers.
 * @summary Lösche Nutzer
 */
 starteNutzerLoeschen<TData = void>(nutzerLoeschenRequest: NutzerLoeschenRequest, options?: HttpClientBodyOptions): Observable<TData>;
 starteNutzerLoeschen<TData = void>(nutzerLoeschenRequest: NutzerLoeschenRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 starteNutzerLoeschen<TData = void>(nutzerLoeschenRequest: NutzerLoeschenRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  starteNutzerLoeschen<TData = void>(
    nutzerLoeschenRequest: NutzerLoeschenRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/userprofil/`,{body: nutzerLoeschenRequest,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }}
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/userprofil/`,{body: nutzerLoeschenRequest,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }}
    );
    }

    return this.http.delete<TData>(
      `/api/userprofil/`,{body: nutzerLoeschenRequest,...{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }}
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen von Informationen über den aktuell eingeloggten Nutzer.
 * @summary Abruf Nutzerdaten
 */
 getUserData<TData = UserData>(benutzerId: string, options?: HttpClientBodyOptions): Observable<TData>;
 getUserData<TData = UserData>(benutzerId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getUserData<TData = UserData>(benutzerId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getUserData<TData = UserData>(
    benutzerId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/userprofil/${benutzerId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/userprofil/${benutzerId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/userprofil/${benutzerId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

